<div class="volume form-group">
  <label
    id="choose-volume-label"
    for="choose-volume"
    data-automation-id="choose-volume-label"
    class="volume__label"
  >
    {{ "Volume" | translate }}
  </label>
  <select
    class="form-control volume__select select-custom-arrow"
    id="choose-volume"
    [(ngModel)]="selectedVolumeCode"
    [disabled]="disabled"
    (change)="onVolumeChange($event.target.value)"
    [attr.data-automation-id]="dataAutomationId"
    aria-labelledby="choose-volume-label"
  >
    <option
      *ngFor="let volume of volumes"
      [value]="volume.code"
      data-automation-id="volumeOption"
    >
      {{ volume.code }}
    </option>
  </select>
</div>
